<template>
    <div class="node-properties-inner">
        <selector :options="[
            { value: 'crosses-into', label: 'Enters' },
            { value: 'crosses-out-of', label: 'Leaves' },
            { value: 'inside', label: 'Inside' },
            { value: 'outside', label: 'Outside' }
        ]" v-model="properties.trigger" />

        <template v-if="properties.trigger == 'inside' || properties.trigger == 'outside'">
            <label>Duration</label>
            <input v-model.number="properties.triggerDuration">
            <label class="units">s</label>
        </template>

        <label>Message</label>
        <input v-model="properties.message">
    </div>
</template>

<script>
import Selector from "@/components/nodes/Selector.vue";

export default {
    props: {
        properties: { type: Object, required: true }
    },
    components: { Selector }
}
</script>